import styled from 'styled-components';
import DownloadSvg from '../../assets/wallet/download.svg';

const DownaloadNew = styled(DownloadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '2.5rem'};
    height: ${props => props.height || '2.5rem'};
    fill: ${props => props.fill || 'none'};
`;

export default DownaloadNew;
